/* eslint-disable camelcase */
import { useMount } from "ahooks";
import { Layout } from "antd";
import Cookies from "js-cookie";
import { Suspense, useRef } from "react";
import { useLocation, useRoutes } from "react-router-dom";

import { Header } from "@/components/header/header";
import { Env } from "@/config/env";
import {
  EFFECTIVE_DURATION,
  REFRESH_TOKEN_IN_COOKIE,
  REFRESH_TOKEN_LOCK_KEY,
  TOKEN_EXPIRE,
  TOKEN_IN_COOKIE,
} from "@/libs/constants";
import routes from "@/routes";
import { api } from "@/services/api";
import { showIndexHeader } from "@/utils/route";
import { localGet, localRemove, localSet } from "@/utils/storage";
/**
 * 应用入口
 */
function AppLayout() {
  const element = useRoutes(routes);

  const { pathname } = useLocation();

  const intervalId = useRef<NodeJS.Timer>();

  const handleRefreshToken = async () => {
    const refreshToken = Cookies.get(REFRESH_TOKEN_IN_COOKIE);

    const localLock = localGet(REFRESH_TOKEN_LOCK_KEY);

    if (!refreshToken || localLock) {
      return;
    }

    localSet(REFRESH_TOKEN_LOCK_KEY, 1);

    const urlParams = new URLSearchParams();

    urlParams.append("grant_type", "refresh_token");
    urlParams.append("client_id", Env.VITE_APP_PKCE_APP_ID);
    refreshToken && urlParams.append("refresh_token", refreshToken);
    const currentDate = new Date();

    const response = await api.post(Env.OME_URL + "/connect/token", urlParams, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.status == 200) {
      const { access_token, refresh_token, token_type, expires_in } =
        response.data;

      const expire = expires_in * 1000 + currentDate.getTime();

      const refleshExpire = 30 * 24 * 60 * 60 * 1000 + currentDate.getTime();

      localSet(TOKEN_EXPIRE, expire);
      localSet(EFFECTIVE_DURATION, expires_in - 600);

      Cookies.set(TOKEN_IN_COOKIE, token_type + " " + access_token, {
        domain: Env.DOMAIN,
        expires: new Date(expire),
      });
      Cookies.set(REFRESH_TOKEN_IN_COOKIE, refresh_token, {
        domain: Env.DOMAIN,
        expires: new Date(refleshExpire),
      });
      localRemove(REFRESH_TOKEN_LOCK_KEY);
      intervalId.current = setTimeout(() => {
        handleRefreshToken();
      }, (expires_in - 600) * 1000);
    }
  };

  useMount(() => {
    localRemove(REFRESH_TOKEN_LOCK_KEY);
    const expire = localGet(TOKEN_EXPIRE);

    if (expire - new Date().valueOf() <= 600000) {
      handleRefreshToken();
    } else {
      clearTimeout(intervalId.current);
      intervalId.current = setTimeout(() => {
        handleRefreshToken();
      }, expire - new Date().valueOf() - 600000);
    }
  });

  return (
    <Layout style={{ position: "relative", background: "#ffffff" }}>
      {showIndexHeader(pathname) && <Header />}
      <Suspense>{element}</Suspense>
    </Layout>
  );
}

export default AppLayout;
